import React from 'react';

const BucketEmptyConfirmPopup = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    productName = "this item" 
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl p-6 mx-4 max-w-sm w-full">
                {/* Header */}
                <div className="text-center mb-4">
                    <div className="w-16 h-16 mx-auto mb-3 bg-red-100 rounded-full flex items-center justify-center">
                        <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    </div>
                </div>

                {/* Message */}
                <div className="text-center mb-6">
                    <p className="text-gray-600 text-sm leading-relaxed">
                        You're about to empty your bucket. Removing this item will leave your bucket empty.
                    </p>
                    <p className="text-gray-800 font-medium text-sm mt-2">
                        Are you sure?
                    </p>
                </div>

                {/* Buttons */}
                <div className="flex space-x-3">
                    {/* Yes, Remove Button */}
                    <button
                        onClick={onConfirm}
                        className="flex-1 bg-red-500 text-white py-2.5 px-4 rounded-md font-medium text-sm hover:bg-red-600 transition-colors duration-200"
                    >
                        Yes, Remove
                    </button>
                    
                    {/* No, Keep It Button */}
                    <button
                        onClick={onClose}
                        className="flex-1 bg-gray-100 text-gray-700 py-2.5 px-4 rounded-md font-medium text-sm hover:bg-gray-200 transition-colors duration-200 border border-gray-300"
                    >
                        No, Keep It
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BucketEmptyConfirmPopup;
